// Centralized permission constants for dashboard modules
// Add or write permissions here to control access throughout the app

export const PERMISSIONS = {
  // Categories
  CATEGORY_READ: "category:read",
  CATEGORY_CREATE: "category:create",
  CATEGORY_EDIT: "category:write",
  CATEGORY_DELETE: "category:delete",

  // Dining Tables
  DINING_TABLE_READ: "restaurant_table:read",
  DINING_TABLE_CREATE: "restaurant_table:write",
  DINING_TABLE_EDIT: "restaurant_table:write",
  DINING_TABLE_DELETE: "restaurant_table:delete",

  // Kiosk
  KIOSK_READ: "kiosk:read",
  KIOSK_CREATE: "kiosk:write",
  KIOSK_EDIT: "kiosk:write",
  KIOSK_DELETE: "kiosk:delete",

  // Products
  PRODUCT_READ: "product:read",
  PRODUCT_CREATE: "product:write",
  PRODUCT_EDIT: "product:write",
  PRODUCT_DELETE: "product:delete",

  // Orders
  ORDER_READ: "order:read",
  ORDER_CREATE: "order:write",
  ORDER_EDIT: "order:write",
  ORDER_DELETE: "order:delete",
};
